module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"h1":"Security code","h2":"Security code was sent to {email}"},"ru":{"h1":"Код безопасности","h2":"Подтвердите свою электронную почту. Код отправлен {email}","enter-number":"Вернуться к вводу номера"}}')
  delete Component.options._Ctor
}
